module.exports = __webpack_public_path__ + "static/media/calendar.f4410bf2.svg";